import React, { useEffect, useState, useContext } from 'react';
import { Card, CardBody } from 'reactstrap';
import axios from 'axios';
import { Table, InputNumber, Input, Form, message, Image, Avatar, Col, Modal } from 'antd';
import { URL } from '../../../config/api';
import { useHistory } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { disableSpinner, enableSpinner } from '../../../redux/actions/appActions';
import AuthContext from '../../App/authContext';
import ModalBody from './ModalBody';
import { ExclamationCircleOutlined, EditOutlined, DeleteOutlined } from '@ant-design/icons';

const EditableCell = ({
  editing,
  dataIndex,
  title,
  inputType,
  record,
  index,
  children,
  ...restProps
}) => {
  const inputNode = inputType === 'number' ? <InputNumber /> : <Input />;
  return (
    <td {...restProps}>
      {editing ? (
        <Form.Item
          name={dataIndex}
          style={{
            margin: 0,
          }}
        >
          <Input style={{width: '60px'}} />
        </Form.Item>
      ) : (
        children
      )}
    </td>
  );
};

const ExampleCard = ({setModalVisible, modalVisible, setUpdate, update}) => {
  const [results, setResults] = useState([]);
  const [categories, setCategories] = useState([]);
  const [editModalVisible, setEditModalVisible] = useState(false);
  const [selectedSticker, setSelectedSticker] = useState(null);

  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const token = localStorage.getItem('token');
  const id = localStorage.getItem('id');
  const { confirm } = Modal;

  useEffect(() => {
    loadResults();
  }, []);

  const loadResults = async () => {
    const bodyFormData = new FormData();
    bodyFormData.append('UserId', id);
    bodyFormData.append('Token', token);
    try {
      const res = await axios.post(`${URL}/sticker/get_stickers.php`, bodyFormData);
      if(res.data.Success) {
        const data = res.data.Data;
        data.forEach((item, index) => {
          item.key = index
        });
        setResults(data);
        setCategories(res.data.Data1);
      }else {
        alert(res.data.Message);
      }
    }catch(error) {
      console.log(error);

    }
  }

  const openEditModal = (sticker) => {
    setUpdate(update + 1);
    setEditModalVisible(true);
    setSelectedSticker(sticker);
  }

  const deleteSticker = (sticker) => {
    confirm({
      title: 'Are you sure delete this sticker?',
      icon: <ExclamationCircleOutlined />,
      okText: 'Yes',
      okType: 'danger',
      cancelText: 'No',
      onOk() {
        console.log('OK');
        deleteStickerWithId(sticker.Id);
      },
      onCancel() {
        console.log('Cancel');
      },
    });
  }

  const deleteStickerWithId = async (stickerId) => {
    const bodyFormData = new FormData();
    bodyFormData.append('UserId', id);
    bodyFormData.append('Token', token);
    bodyFormData.append('Id', stickerId);

    dispatch(enableSpinner('Deleting..'));
    const res = await axios.post(`${URL}/sticker/delete_sticker.php`, bodyFormData);
    dispatch(disableSpinner());

    if(res.data.Success) {
      message.success(res.data.Message);
      loadResults();
    } else {
      message.error(res.data.Message);
    }
  }

  const handleSubmit = async (values, index) => {
    console.log("FORM_SUBMIT", values);
    const bodyFormData = new FormData();
    bodyFormData.append('UserId', id);
    bodyFormData.append('Token', token);
    bodyFormData.append('CategoryId', values.categoryId);
    bodyFormData.append('ImageName', values.name);
    bodyFormData.append('Tag', values.tags);
    bodyFormData.append('SvgUrl', values.svgUrl);

    try {
      console.log("Values", values);
      if(index === 0) {
        if(values.imageUrl == "") {
          message.error("Image is required");
          return;
        }
        
        if(values.categoryId == 0) {
          message.error("Category is required");
          return;
        }

        setModalVisible(false);

        dispatch(enableSpinner('Loading..'));
        const res = await axios.post(`${URL}/sticker/add_sticker.php`, bodyFormData);
        dispatch(disableSpinner());

        if(res.data.Success) {
          message.success(res.data.Message);
          loadResults();
        } else {
          message.error(res.data.Message);
        }
      } else {
        bodyFormData.append('ImageUrl', values.imageUrl);
        setEditModalVisible(false);
        bodyFormData.append('Id', selectedSticker.Id);

        dispatch(enableSpinner('Loading..'));
        const res = await axios.post(`${URL}/sticker/update_sticker.php`, bodyFormData);
        dispatch(disableSpinner());

        if(res.data.Success) {
          message.success(res.data.Message);
          loadResults();
        } else {
          message.error(res.data.Message);
        }
      }
    }catch(error) {
      console.log(error);
      dispatch(disableSpinner());
    }
  }

  const columns = [
    {
      title: 'Image',
      dataIndex: 'ImageUrl',
      key: 'ImageUrl',
      render: ((value, record) => (
        <Image
          width={100}
          height={100}
          src={record.ImageUrl}
        />
      ))
    },
    {
      title: 'Image Name',
      dataIndex: 'ImageName',
      key: 'ImageName',
    },
    {
      title: 'Tag',
      dataIndex: 'Tag',
      key: 'Tag',
    },
    {
      title: 'Edit',
      dataIndex: '',
      key: 'edit',
      fixed: 'right',
      render: (_, record) => {
        return (
          <span
            onClick={() => openEditModal(record)}
            style={{
              cursor: 'pointer',
              color: '#1890ff'
            }}
          >
          <EditOutlined />
          </span>
        )
      }
    },
    {
      title: 'Delete',
      dataIndex: '',
      key: 'delete',
      fixed: 'right',
      render: (_, record) => {
        return (
          <span
            onClick={() => deleteSticker(record)}
            style={{
              cursor: 'pointer',
              color: '#1890ff'
            }}
          >
          <DeleteOutlined />
          </span>
        )
      }
    },
  ]

  return (
    <Col span={24}>
      <Card>
        <CardBody>
          <Form form={form} component={false}>
            <Table 
              components={{
                body: {
                  cell: EditableCell
                }
              }} 
              columns={columns} 
              dataSource={results} />
          </Form>
        </CardBody>
      </Card>
      <Modal
        title={`Add Sticker`}
        width="30%"
        visible={modalVisible}
        onCancel={() => setModalVisible(false)}
        onOk={() => setModalVisible(false)}
        footer={null}
      >
      <ModalBody close={() => setModalVisible(false)} handleSubmit={(values) => handleSubmit(values, 0)} update={update} categories={categories}/>
      </Modal>

      <Modal 
        title="Edit Sticker"
        width="30%"
        visible={editModalVisible}
        onCancel={() => setEditModalVisible(false)}
        footer={null}>
          <ModalBody 
            close={() => {setSelectedSticker(null); setEditModalVisible(false); }} 
            handleSubmit={(values) => handleSubmit(values, 1)}
            sticker={selectedSticker}
            update={update}
            categories={categories} />
        </Modal>
    </Col>
  );
}



export default ExampleCard;
